<template>
  <div>
    <v-tabs
      v-model="active"
      color="cyan"
      dark
      slider-color="yellow"
    >
      <v-tab key="0" ripple>
        Application
      </v-tab>
      <v-tab key="1" ripple>
        Dashboard
      </v-tab>
      <v-tab-item key="0">
          <ProjectParameter />
      </v-tab-item>
      <v-tab-item key="1">
          <LayoutParameter />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import LayoutParameter from "@/components/charts/LayoutParameter.vue";
import ProjectParameter from "@/components/charts/ProjectParameter.vue";
export default {
    data: function() {
      return {
        active: 0
      };
    },
    methods: {

    },
    computed: {
    },
    components: {
        LayoutParameter,
        ProjectParameter
    },
    mounted: function() {

    }
}

</script>
